export default __webpack_public_path__ + "static/media/5kg.b83c1db7.jpeg";